const getStorageItem = (key, parse = true) => {
    try {
        const item = localStorage.getItem(key);
        if (item === null) {
            throw new Error(`Item with key "${key}" does not exist in localStorage.`);
        }
        if (parse) {
            return JSON.parse(item);
        }
        return item;
    } catch (error) {
        console.error(`Error getting item from localStorage: ${error.message}`);
        return null;
    }
};

const setStorageItem = (key, value) => {
    try {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
    } catch (error) {
        console.error(`Error setting item in localStorage: ${error.message}`);
    }
};

const removeStorageItem = (key) => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.error(`Error removing item from localStorage: ${error.message}`);
    }
};

const clearStorage = () => {
    try {
        localStorage.clear();
    } catch (error) {
        console.error(`Error clearing localStorage: ${error.message}`);
    }
};

const getAuthData = () => {
    return getStorageItem("authData");
}

export { getStorageItem, setStorageItem, removeStorageItem, clearStorage, getAuthData };
